import { BaseFeature, FeatureType } from '@core/shared/feature';
export class CmsBaseFeature extends BaseFeature {
  static {
    this.featureInfo = {
      context: {"package":"@common/cms/feature","featureId":"common-cms"},
      bundledItemModels: ["CmsModuleItem"],
      // list is auto-generated by generate-model-ids
      abilityActions: false,
      plugins: [{
        forPlatform: 'admin',
        type: FeatureType.Permanent,
        pluginClassName: 'CmsFrontendAdminFeature'
      }, {
        forPlatform: 'backend',
        type: FeatureType.Permanent,
        pluginClassName: 'CmsBackendFeature'
      }, {
        forPlatform: 'backend-admin',
        type: FeatureType.Permanent,
        pluginClassName: 'CmsBackendAdminFeature'
      }]
    };
  }
  getSharedDefinition() {
    return {};
  }
}